import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { MdKeyboardArrowDown } from 'react-icons/md';

import { Input } from '../input';

import { useOnClickOutside } from 'hooks';
import { KeyCodes } from 'constants/keyCodes';
import './Dropdown.css';

const Dropdown = ({
    align = 'right',
    id,
    fontSize,
    label,
    searchable,
    showTextWhenSelected = true,
    value,
    maxHeight,
    noResultsText,
    noSemicolon,
    onChange,
    options = [],
    variant = 'standard',
    width,
    extraClass,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [dropdownValue, setDropdownValue] = useState(value);
    const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
    const [dropdownOptions, setOptions] = useState(options);
    const dropdownRef = useRef(null);
    const searchInputRef = useRef(null);

    const handleKeyDown = (event) => {
        if (
            event.keyCode === KeyCodes.ESCAPE ||
            event.keyCode === KeyCodes.TAB
        ) {
            setIsOpen(false);
            setOptions(options);
        }

        // TODO: IMPLEMENT THIS
        // else if (event.keyCode === KeyCodes.ENTER) {
        //     handleEnterKeyDown(event);
        // } else if (
        //     event.keyCode === KeyCodes.ARROW_DOWN ||
        //     event.keyCode === KeyCodes.ARROW_UP
        // ) {
        //     handleArrowUpOrDownKeyDown(event);
        // }
    };

    // const handleEnterKeyDown = (event) => {
    //     event.preventDefault();
    //     setSelectedOption(dropdownOptions[selectedOptionIndex]);
    //     setIsOpen(false);
    // };

    // TODO: IMPLEMENT THIS
    // const handleArrowUpOrDownKeyDown = (event) => {
    //     const optionsNo = dropdownOptions.length;

    //     if (event.keyCode === KeyCodes.ARROW_DOWN) {
    //         if (selectedOptionIndex + 1 < optionsNo) {
    //             setSelectedOptionIndex(selectedOptionIndex + 1);
    //         }
    //     }
    // };

    useOnClickOutside(dropdownRef, () => {
        setIsOpen(false);
        setOptions(options);
    });
    useEffect(() => {
        let selectedOptionTmp;
        let selectedOptionIndex;

        for (let index = 0; index < options.length; index++) {
            const option = options[index];
            if (value && option?.dropdownSelected) {
                selectedOptionTmp = option;
                setSelectedOption(option);
                setDropdownValue(option.dropdownValue);
                setSelectedOptionIndex(index);
                selectedOptionIndex = index;
            } else if (
                dropdownValue &&
                option.dropdownValue === dropdownValue
            ) {
                selectedOptionTmp = option;
                setSelectedOption(option);
                setDropdownValue(option?.dropdownValue);
                setSelectedOptionIndex(index);
                selectedOptionIndex = index;
            } else if (!dropdownValue && option?.dropdownSelected) {
                selectedOptionTmp = option;
                setSelectedOption(option);
                setDropdownValue(option.dropdownValue);
                setSelectedOptionIndex(index);
                selectedOptionIndex = index;
            }
        }

        if (!selectedOptionTmp) {
            const option = options[0];
            if (option) {
                setSelectedOption(options[0]);
                setDropdownValue(options[0]?.dropdownValue);
                setSelectedOptionIndex(0);
            }
        } else {
            setSelectedOption(selectedOptionTmp);
            setDropdownValue(selectedOptionTmp.dropdownValue);
            setSelectedOptionIndex(selectedOptionIndex);
        }

        setOptions(options);
    }, [options, value]);

    return (
        <div className={`ab-flex-class ${extraClass}`} ref={dropdownRef}>
            <div
                className={`ab-current ab-dropdown--${variant}`}
                tabIndex="0"
                onClick={() => {
                    // If search input has focus then return
                    if (
                        searchInputRef.current &&
                        searchInputRef.current === document.activeElement
                    ) {
                        return;
                    }

                    setIsOpen(!isOpen);
                    setOptions(options);
                }}
                onKeyDown={handleKeyDown}
            >
                {noSemicolon ? (
                    <div className="ab-label">{label}</div>
                ) : (
                    <div className="ab-label">{label} :</div>
                )}

                <div className="ab-titleWithIcon">
                    <div className="ab-value" style={{ fontSize: fontSize }}>
                        {selectedOption?.dropdownImg && (
                            <img
                                className="ab-dropdown-img"
                                src={selectedOption?.dropdownImg}
                            />
                        )}
                        {showTextWhenSelected && selectedOption?.dropdownText}
                    </div>
                    <div className="ab-icon">
                        {<MdKeyboardArrowDown size={20} />}
                    </div>
                </div>

                {isOpen && (
                    <div className={`ab-dropdown ab-dropdown--${align}`}>
                        <div
                            className="ab-dropdown-content"
                            style={{ width: width, minWidth: width }}
                        >
                            {searchable && (
                                <Input
                                    autoFocus
                                    id="dropdown-search-input"
                                    onChange={(event) => {
                                        const searchText = event.target.value;
                                        if (searchText === '') {
                                            setOptions(options);
                                            return;
                                        }

                                        setOptions(
                                            dropdownOptions.filter((option) => {
                                                return option?.dropdownText
                                                    .toLowerCase()
                                                    .includes(
                                                        searchText.toLowerCase()
                                                    );
                                            })
                                        );
                                    }}
                                    ref={searchInputRef}
                                />
                            )}
                            <ul
                                className="ab-custom-scrollbar"
                                role="tablist"
                                tabIndex="0"
                                style={{
                                    fontSize: fontSize,
                                    maxHeight: maxHeight,
                                }}
                            >
                                {dropdownOptions?.length > 0 &&
                                    dropdownOptions.map((option, index) => {
                                        return (
                                            <li
                                                className={`${
                                                    selectedOptionIndex ===
                                                    index
                                                        ? 'ab-selected-dropdown-option'
                                                        : ''
                                                }`}
                                                role="tab"
                                                aria-label={option.dropdownText}
                                                aria-selected={
                                                    selectedOptionIndex ===
                                                    index
                                                }
                                                tabIndex="0"
                                                key={index}
                                                onClick={() => {
                                                    setSelectedOption(option);
                                                    setDropdownValue(
                                                        option.dropdownValue
                                                    );
                                                    setSelectedOptionIndex(
                                                        index
                                                    );
                                                    onChange(option);
                                                }}
                                            >
                                                <div className="ab-dropdown-option">
                                                    {option?.dropdownImg && (
                                                        <img
                                                            className="ab-dropdown-img"
                                                            src={
                                                                option?.dropdownImg
                                                            }
                                                        />
                                                    )}
                                                    <span className="ab-dropdown-text">
                                                        {option.dropdownText}
                                                    </span>
                                                </div>
                                            </li>
                                        );
                                    })}

                                {dropdownOptions?.length === 0 && (
                                    <li role="tab" tabIndex="0">
                                        {noResultsText}
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const optionShape = PropTypes.shape({
    dropdownText: PropTypes.string,
    dropdownValue: PropTypes.any.isRequired,
    dropdownImg: PropTypes.string,
    dropdownSelected: PropTypes.bool,
});

Dropdown.propTypes = {
    align: PropTypes.oneOf(['left', 'right', 'left-unset']),
    id: PropTypes.string,
    fontSize: PropTypes.string,
    label: PropTypes.string,
    searchable: PropTypes.bool,
    showTextWhenSelected: PropTypes.bool,
    value: PropTypes.any,
    noResultsText: PropTypes.string,
    noSemicolon: PropTypes.bool,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(optionShape).isRequired,
    width: PropTypes.string,
    maxHeight: PropTypes.string,
    variant: PropTypes.oneOf(['standard', 'outlined']),
    extraClass: PropTypes.string,
};

export default Dropdown;
